import { apiFetch } from '@carouselgg/auth/client'

/**
 * Side swaps — a captain asking the other to swap starting sides on a game
 * not yet played. The app answers one inline from its notification; the org
 * match page makes them (org/src/api/sideSwaps.ts).
 */

export interface SideSwap {
  id: string
  game_number: number
  requested_by_team_id: string
  message: string
  status: 'pending' | 'accepted' | 'declined' | 'cancelled'
  created_at: string
  answered_at: string | null
}

export interface GameStartingSide {
  game_number: number
  first_side_team_id: string
  set: boolean
  set_at: string | null
}

/** A request with what the answering captain needs: their team and every game's sides. */
export interface SideSwapDetail extends SideSwap {
  match_id: string
  map: string
  /** The team the viewer captains in this match. */
  team_id: string
  teams: { team_id: string; name: string }[]
  side_names: string[]
  starting_sides: GameStartingSide[]
  swaps: SideSwap[]
}

export function getSideSwap(orgId: string, swapId: string) {
  return apiFetch<SideSwapDetail>(`/events/${orgId}/side-swaps/${swapId}`)
}

export function answerSideSwap(orgId: string, swapId: string, accept: boolean) {
  return apiFetch<SideSwap>(`/events/${orgId}/side-swaps/${swapId}/answer`, {
    method: 'POST',
    body: JSON.stringify({ accept }),
  })
}
